/* tslint:disable */
/* eslint-disable */
/**
 * BusService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { GetNearbyRoutesParameters } from '../model';
// @ts-ignore
import { GetNearbyRoutesResult } from '../model';
/**
 * GetNearbyRoutesApiApiGetNearbyRoutesPost - axios parameter creator
 * 
 * @param {GetNearbyRoutesParameters} [getNearbyRoutesParameters] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function GetNearbyRoutesApiApiGetNearbyRoutesPostAxiosParamCreator (getNearbyRoutesParameters?: GetNearbyRoutesParameters, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/GetNearbyRoutes`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(getNearbyRoutesParameters, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiGetNearbyRoutesPost operation in GetNearbyRoutesApi.
 * @export
 * @interface GetNearbyRoutesApiApiGetNearbyRoutesPostRequest
 */
export interface GetNearbyRoutesApiApiGetNearbyRoutesPostRequest {
    /**
     * 
     * @type {GetNearbyRoutesParameters}
     * @memberof GetNearbyRoutesApiApiGetNearbyRoutesPost
     */
    readonly getNearbyRoutesParameters?: GetNearbyRoutesParameters
}

/**
* 
* @param {GetNearbyRoutesApiApiGetNearbyRoutesPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function GetNearbyRoutesApiApiGetNearbyRoutesPost(requestParameters: GetNearbyRoutesApiApiGetNearbyRoutesPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await GetNearbyRoutesApiApiGetNearbyRoutesPostAxiosParamCreator(requestParameters.getNearbyRoutesParameters, options, configuration);
    const request: () => AxiosPromise<GetNearbyRoutesResult> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
